import { apiRequestDev } from './apiRequest';

export const getSettings = async (config, userId) => apiRequestDev(config, `/users/settings/${userId}`);

export const saveNotificationsSettings = async (config, userId, email, sms, frequency, xMessages) => {
  return apiRequestDev(config, '/users/notifications', 'patch', {
    user_id: userId,
    email,
    sms,
    frequency,
    x_messages: xMessages,
  });
};

export const getEmailSettings = async (config, userId) => apiRequestDev(config, `/users/email_settings/${userId}`);

export const saveEmailSettings = async (config, userId, settings, autoMessagesApproval) => {
  return apiRequestDev(config, '/users/email_settings', 'patch', {
    user_id: userId,
    settings,
    auto_messages_approval: autoMessagesApproval,
  });
};

export const saveAuthSettings = async (config, userId, method) => {
  return apiRequestDev(config, '/users/auth_settings', 'patch', {
    user_id: userId,
    method,
  });
};

export const saveProfileSettings = async (config, userId, phone) => {
  return apiRequestDev(config, '/users/profile_settings', 'patch', {
    user_id: userId,
    phone,
  });
};

export const sendVerification = async (config, emailId) => {
  return apiRequestDev(config, '/users/email_verification', 'post', {
    email_id: emailId,
  });
};
